import * as Api from "../../api";
import Vue from "vue";
import Utils from "../../untils";

const state = {
  refreshTrigger: 0
};

const getters = {};

const mutations = {
  triggerCouponRefresh(state) {
    state.refreshTrigger = Math.random();
  }
};

const actions = {

  getCouponCode({ state }, { params, callback }) {
    let obj = {
      action: `/oa/coupon/generate`,
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getCouponCodeCallback");
      }
    });
  },

  saveCouponDetails({ state }, { params, callback }) {
    let obj = {
      action: `/oa/coupon/save`,
      ...params,
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "saveCouponDetailsCallback");
      }
    });
  },
  getAllCoupons({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/coupon/get/all/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAllCouponsCallback");
      }
    });
  },
  getAllocatedCoupons({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/coupon/get/allocatedCoupons/${params.couponId}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAllocatedCouponsCallback");
      }
    });
  },
  refreshCouponList({ commit }) {
    commit('triggerCouponRefresh');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/coupon.js